import React from 'react';
import "./Footer.css"

export default function Footer() {
  return (
    <div className="container-fluid d-flex flex-column justify-content-center align-items-center text-align-center toer">
        <p>All Right Reserved</p>
        <p>By continuing to use this site, you agree to the</p>
          <p> Terms of Service</p>
    </div>
  )
}
